import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useAbility } from 'providers/casl'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO } from './api/mapper'
import { GET_RICH_PLACEMENT_K_WORDS } from './api/query'

import type { Data, Variables } from './api/types'
import type { RichPlacementKWordsSlice, UseGetRichPlacementKWords } from './types'

export const useGetRichPlacementKWords = (): UseGetRichPlacementKWords => {
  const { workspaceId } = useWorkspaceParam()
  const ability = useAbility()

  const { data, isLoading } = useQuery<Variables, Data, RichPlacementKWordsSlice>({
    options: {
      select: ({ workspaceRichPlacementKwordsConfiguration }: Data): RichPlacementKWordsSlice =>
        fromDTO(workspaceRichPlacementKwordsConfiguration),
    },
    query: GET_RICH_PLACEMENT_K_WORDS(ability),
    variables: { workspaceId },
  })

  return { isLoading, kWords: data }
}
